module.exports = __webpack_public_path__ + "static/media/ic_subscription_grey.f6d346ec.svg";